import { createMemo, For, Match, Switch } from "solid-js";
import { diffWords } from "@time-tracker/shared";

interface WordDiffProps {
  oldText: string;
  newText: string;
  class?: string;
}

/**
 * Theme-aware render of the word-level diff (PROJECT VERSIONING): `added` in a
 * soft green, `removed` struck-through in a soft red. `data-diff` for e2e.
 */
export function WordDiff(props: WordDiffProps) {
  const segments = createMemo(() => diffWords(props.oldText, props.newText));
  return (
    <p
      class={`whitespace-pre-wrap break-words text-sm leading-[1.75] text-foreground ${props.class ?? ""}`}
      data-testid="word-diff"
    >
      <For each={segments()}>
        {(segment) => (
          <Switch fallback={segment.text}>
            <Match when={segment.type === "added"}>
              <ins class="rounded-sm bg-success/20 px-0.5 no-underline" data-diff="added">
                {segment.text}
              </ins>
            </Match>
            <Match when={segment.type === "removed"}>
              <del
                class="rounded-sm bg-danger/10 px-0.5 text-muted-foreground line-through decoration-danger/50"
                data-diff="removed"
              >
                {segment.text}
              </del>
            </Match>
          </Switch>
        )}
      </For>
    </p>
  );
}
